import store from "@/shared/store";
import Api from "@/api";

export async function bootstrap(to) {
  let _request = Promise.all([
    Api.system.getUserPermission(),
    Api.common.getStaticValues()
  ]);
  let [{ permissions }, { properties: config }] = await _request;
  //权限处理
  let permission = {};
  permissions.forEach(item => {
    permission[item.permission_path] = true;
  });
  store.commit("setPermission", permission);
  //config 处理
  store.commit("setConfig", config);
  await getOrderStatus();
  await getUnReadCount();
  return store.getters.isGranted(to.meta.permission);
}

export async function getUserPermission() {
  let { permissions } = await Api.system.getUserPermission();
  let permission = {};
  permissions.forEach(item => {
    permission[item.permission_path] = true;
  });
  store.commit("setPermission", permission);
}

export async function getOrderStatus() {
  let { statuses } = await Api.order.getStatus();
  store.commit("setOrderStatus", {
    process: statuses[0],
    done: statuses[1],
    closed: statuses[2]
  });
}

export async function getUnReadCount() {
  try {
    let { count } = await Api.account.getUnReadCount();
    store.commit("setMessage", count);
  } catch (e) {}
}
